
import { Options } from "vue-class-component";

import BasePage from "@/common/BasePage";

import OrderVo from "@/vo/OrderVo";

import AppUtil from "@/util/AppUtil";
import ServeItem from "@/components/item/ServeItem.vue";
import { Popup, Toast } from "vant";

@Options({
  components: {
    [Popup.name]: Popup,
    "serve-item": ServeItem,
  },
})
export default class OrderDetail extends BasePage {
  order: OrderVo = new OrderVo();
  mounted() {
    if (!this.$route.query.code) {
      Toast("查无此订单，即将返回");
      setTimeout(() => {
        this.$router.replace({
          path: "/staff/search",
          query:{type:0}
        });
      }, 1000);
      return;
    }
    AppUtil.request(
      {
        url: "/zhStaff/staff/getScanServeOrderInfo",
        method: "post",
        data: { orderId: this.$route.query.code },
      },
      (res: any) => {
        // console.log(res);
        this.order = new OrderVo(res.data);
      },
      "正在加载订单...",
      (success: boolean) => {
        if (!success) {
          setTimeout(() => {
            this.$router.replace({
              path: "/staff/search",
               query:{type:0}
            });
          }, 1000);
        }
      }
    );
  }
  private btn_click() {
    AppUtil.request(
      {
        url: "/zhOrder/serveOrder/confirmWriteOff",
        method: "post",
        data: { allServeNum: this.order.pdcArr.length, orderId: this.order.id },
      },
      (res: any) => {
        Toast("核销成功,返回核销页面");
        setTimeout(() => {
            this.$router.replace({
              path: "/staff/search",
            });
          }, 2000);
         
      },
      "等待后台核销...",
      
    );
  }
}
